export const PROGRAM_DAY_KEYS = Object.freeze([
  "day1",
  "day2",
  "day3",
  "day4",
  "day5",
  "day6",
  "day7",
]);

export const PROGRAM_SLOTS_PER_DAY = 9;

const createEmptyDay = () => ({
  label: "",
  slots: Array.from({ length: PROGRAM_SLOTS_PER_DAY }, () => null),
});

export const createEmptyProgramState = () => ({
  id: null,
  title: "",
  clientName: "",
  startDate: "",
  endDate: "",
  notes: "",
  days: PROGRAM_DAY_KEYS.reduce(
    (days, dayKey) => ({
      ...days,
      [dayKey]: createEmptyDay(),
    }),
    {}
  ),
});
